<template>
	<div class="ringing-notifications">
		<div class="rn-with-all" v-if="list.length > 1">
			<all-notifications @postpone="remindAllLater"></all-notifications>
			<span class="all-notifications notification-eye" :class="{ 'eye-hidden':hidden }" @click="ns.toggleHidden()"><sym-icon name="eye-lashes"></sym-icon></span>
		</div>
		<TransitionGroup v-if="!hidden" name="list">
			<notification-view v-for="n in list" :key="n.id" :notification="n" :closeable="true" :panel="true" @action="doAction"></notification-view>
		</TransitionGroup>
	</div>
</template>

<script setup lang="ts">
import NotificationView from "@/notifications/NotificationView.vue";
import type {Notification} from "@t/meta/Notification.ts";
import AllNotifications from "@/ui/mouse/AllNotifications.vue";
import {computed, ref} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {useNotificationStore} from "@/store/NotificationStore.ts";
import {storeToRefs} from "pinia";

const props = defineProps<{
	list: Notification[]
}>();

const emit = defineEmits(['action']);
const ns = useNotificationStore();
const { hidden } = storeToRefs(ns);

const idArray = computed<number[]>(() => {
	const ids:number[] = [];
	for (let nt of props.list) {
		ids.push(nt.id);
	}
	return ids;
});

function remindAllLater(delay:number) {
	emit('action', "postpone-"+delay, idArray.value);	// postpone 4 hours (240 minutes)
}

function doAction(name: string, ids: number[]) {
	//console.log("ringing doAction " + name);
	emit('action', name, ids);	// just re-emit
}
</script>

<style>
.ringing-notifications {
	position: fixed;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	row-gap: 8px;
	top: 0;
	right: 0;
	padding: 60px 16px 16px 16px;
	height: 100vh;
	width: 332px;
	z-index: var(--modal-z-index);
	overflow-x: visible;
	overflow-y: auto;
	scrollbar-width: none;
	pointer-events: none;
	box-sizing: border-box;
}
.rn-with-all {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}
.notification-eye {
	position: relative;
}
.eye-hidden {
	color: color-mix(in srgb, var(--button-ternary-fg), var(--button-ternary-bg));
}
.eye-hidden:before {
	content: '';
	height: 1px;
	width: 24px;
	background-color: var(--red);
	border-bottom: 1px solid var(--button-ternary-bg);
	position:absolute;
	top: 14px;
	left: 14px;
	transform: rotate(-45deg);
}

/* apply transition to moving elements */
.list-move,
.list-enter-active,
.list-leave-active {
	transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
	opacity: 0;
	transform: scale(0.5);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
	position: absolute;
}
</style>